import { useCallback } from 'react';
import cx from 'classnames';
import BootstrapButton from 'react-bootstrap/Button'
import Loader from '../Loader/Loader';
import styles from './Button.module.scss';

const Button = ({
  children,
  className,
  variant = 'filled', // filled | outline
  color = 'primary', // 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link'
  iconBefore,
  iconAfter,
  loading,
  size,
  active,
  fullWidth,
  textClassName,
  hoverStyle, // 'secondary'
  smallPadding,
  style,
  ...rest
}) => {
  const rootClassName = cx(
    styles.root,
    className,
    loading && styles.loading,
    size === 'xlg' && styles.xlg,
    size === 'xs' && styles.xs,
    active && styles.active,
    iconBefore && styles.withIconBefore,
    hoverStyle && styles[`${hoverStyle}HoverStyle`],
    fullWidth && styles.fullWidth,
    smallPadding && styles.smallPadding
  );

  const v = variant === 'outline' ? `outline-${color}` : color;

  // Use ref callback to apply styles with !important
  const buttonRef = useCallback((node) => {
    if (node) {
      // Get all spans inside the button to apply styles
      const spans = node.querySelectorAll('span');

      if (style?.padding) {
        node.style.setProperty('padding', style.padding, 'important');
        node.style.setProperty('height', 'auto', 'important');
      }
      if (style?.fontFamily) {
        node.style.setProperty('font-family', style.fontFamily, 'important');
        // Apply to all spans inside the button
        spans.forEach(span => {
          span.style.setProperty('font-family', style.fontFamily, 'important');
        });
      }
      if (style?.fontSize) {
        node.style.setProperty('font-size', style.fontSize, 'important');
        // Apply to all spans inside the button
        spans.forEach(span => {
          span.style.setProperty('font-size', style.fontSize, 'important');
        });
      }
      if (style?.borderRadius) {
        node.style.setProperty('border-radius', style.borderRadius, 'important');
      }
    }
  }, [style?.padding, style?.fontFamily, style?.fontSize, style?.borderRadius]);

  return (
    <BootstrapButton {...rest} ref={buttonRef} style={style} variant={v} className={rootClassName} size={size}>
      <Loader loading={loading} position="absolute" color="inherit" size={22} thickness={2} />
      {iconBefore && <div className={styles.iconBefore}>{iconBefore}</div>}
      <span className={cx(styles.text, textClassName)}>{children}</span>
      {iconAfter && <div className={styles.iconAfter}>{iconAfter}</div>}
    </BootstrapButton>
  );
};

export default Button;